import React, { Component } from 'react';
import getLocale from '../../../i18n/getLocale';

class SchedulesElaborateRotations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      show: 0,
      sugestoes: this.props.sugestoes,
      data_inicial_90: this.props.data_inicial_90,
      today: this.props.today,
      schedule: this.props.schedule,
      tripulante: this.props.tripulante,
    };

    this.locale = getLocale();
  }
  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && newProps.show !== 0)) {
      this.setState({
        sugestoes: newProps.sugestoes,
        today: newProps.today,
        data_inicial_90: newProps.data_inicial_90,
        tripulante: newProps.tripulante,
        schedule: newProps.schedule,
        show: newProps.show,
        loaded: 1,
      });
    } else if(newProps.show === 0){
      this.setState({
        loaded: 0,
        show: 0,
        data_inicial_90: '',
        tripulante: [],
        schedule: [],
        today: '',
      });

    }
  }
  render() {
    var self = this;
    return (
<div>
  {(self.state.show === 1) ? 
    <div>
      <h3 className="page-title">{this.locale.Escalas.ElaboracaoDeEscala.tituloElaboracaoDeEscalaRodizio}<small> - {self.state.schedule['name']} - {self.state.schedule['aircraft_model']['model'] }</small></h3>
      <hr/>
      <div className="listing table-responsive">
        <table className="table table-bordered table-striped table-hover">
            <thead>
                <tr>
                    <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaElaboracaoDeEscalaRodizio.Base}</th>
                    <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaElaboracaoDeEscalaRodizio.TotalHoras}</th>
                    <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaElaboracaoDeEscalaRodizio.TotalDeTripulantes}</th>
                    <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaElaboracaoDeEscalaRodizio.VagasDisponiveis}</th>
                    <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaElaboracaoDeEscalaRodizio.MediaDeHoras}</th>
                </tr>
            </thead>
            <tbody>
                {Object.keys(self.state.tripulante).map(function(t) {
                  return (
                    <tr>
                        <td>{t}</td>
                        <td>{self.state.tripulante[t]['total_h_base']}</td>
                        <td>{self.state.tripulante[t]['total_t_base']}</td>
                        <td>{self.state.tripulante[t]['vagas_disponiveis_base']}</td>
                        <td>{self.state.tripulante[t]['media_base']}</td>
                    </tr>
                  );
                })}
            </tbody>
        </table>
      </div>
      <hr/>
      <h3 className="page-title">{this.locale.Escalas.ElaboracaoDeEscala.tituloTotalDeHorasEntreCMDT(self.state.data_inicial_90, self.state.today)}</h3>
      <hr/>
      <div className="listing table-responsive">
          <table className="table table-bordered table-striped table-hover">
              <thead>
                  <tr>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaTotalDeHorasEntreCMDT.Total90Dias}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaTotalDeHorasEntreCMDT.Tripulante}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaTotalDeHorasEntreCMDT.Matricula}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaTotalDeHorasEntreCMDT.FB}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaTotalDeHorasEntreCMDT.Base}</th>
                  </tr>
              </thead>
              <tbody>
              {Object.keys(self.state.tripulante).map(function(t) {
                return (
                  Object.keys(self.state.tripulante[t]['Staff']).map(function(s) {
                    return (
                      self.state.tripulante[t]['Staff'][s]["designacao"] == 'CMDT' ?
                        <tr>
                          <td><span style={(self.state.tripulante[t]['Staff'][s]["poucas_horas"] == 1) ? {'color':'red'} : {}}>{self.state.tripulante[t]['Staff'][s]["total_h"]}</span></td>
                          <td>{self.state.tripulante[t]['Staff'][s]["name"]}</td>
                          <td>{self.state.tripulante[t]['Staff'][s]["inscription"]}</td>
                          <td>{self.state.tripulante[t]['Staff'][s]["designacao"]}</td>
                          <td>{t}</td>
                        </tr>
                      : ''
                    );
                  })
                );
              })}
              </tbody>
          </table>
      </div>
      <hr/>
      <h3 className="page-title">{this.locale.Escalas.ElaboracaoDeEscala.tituloTotalDeHorasEntreCOPIL(self.state.data_inicial_90, self.state.today)}</h3>
      <hr/>
      <div className="listing table-responsive">
          <table className="table table-bordered table-striped table-hover">
              <thead>
                  <tr>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaTotalDeHorasEntreCOPIL.Total90Dias}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaTotalDeHorasEntreCOPIL.Tripulante}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaTotalDeHorasEntreCOPIL.Matricula}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaTotalDeHorasEntreCOPIL.FB}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaTotalDeHorasEntreCOPIL.Base}</th>
                  </tr>
              </thead>
              <tbody>
              {Object.keys(self.state.tripulante).map(function(t) {
                return (
                  Object.keys(self.state.tripulante[t]['Staff']).map(function(s) {
                    return (
                      self.state.tripulante[t]['Staff'][s]["designacao"] == 'COPIL' ?
                        <tr>
                          <td><span style={(self.state.tripulante[t]['Staff'][s]["poucas_horas"] == 1) ? {'color':'red'} : {}}>{self.state.tripulante[t]['Staff'][s]["total_h"]}</span></td>
                          <td>{self.state.tripulante[t]['Staff'][s]["name"]}</td>
                          <td>{self.state.tripulante[t]['Staff'][s]["inscription"]}</td>
                          <td>{self.state.tripulante[t]['Staff'][s]["designacao"]}</td>
                          <td>{t}</td>
                        </tr>
                      : ''
                    );
                  })
                );
              })}
              </tbody>
          </table>
      </div>
      <hr/>
      <h3 className="page-title">{this.locale.Escalas.ElaboracaoDeEscala.tituloTotalDeHorasEntreCMS(self.state.data_inicial_90, self.state.today)}</h3>
      <hr/>
      <div className="listing table-responsive">
          <table className="table table-bordered table-striped table-hover">
              <thead>
                  <tr>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaTotalDeHorasEntreCMS.Total90Dias}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaTotalDeHorasEntreCMS.Tripulante}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaTotalDeHorasEntreCMS.Matricula}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaTotalDeHorasEntreCMS.FB}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaTotalDeHorasEntreCMS.Base}</th>
                  </tr>
              </thead>
              <tbody>
              {Object.keys(self.state.tripulante).map(function(t) {
                return (
                  Object.keys(self.state.tripulante[t]['Staff']).map(function(s) {
                    return (
                      self.state.tripulante[t]['Staff'][s]["designacao"] == 'CMS' ?
                        <tr>
                          <td><span style={(self.state.tripulante[t]['Staff'][s]["poucas_horas"] == 1) ? {'color':'red'} : {}}>{self.state.tripulante[t]['Staff'][s]["total_h"]}</span></td>
                          <td>{self.state.tripulante[t]['Staff'][s]["name"]}</td>
                          <td>{self.state.tripulante[t]['Staff'][s]["inscription"]}</td>
                          <td>{self.state.tripulante[t]['Staff'][s]["designacao"]}</td>
                          <td>{t}</td>
                        </tr>
                      : ''
                    );
                  })
                );
              })}
              </tbody>
          </table>
      </div>
      <hr/>
      <h3 className="page-title">{this.locale.Escalas.ElaboracaoDeEscala.tituloSugestaoDeRodizio}</h3>
      <hr/>
      <div className="listing table-responsive">
          <table className="table table-bordered table-striped table-hover">
              <thead>
                  <tr>
                      <th>#</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaSugestaoDeRodizio.Tripulante1}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaSugestaoDeRodizio.FB}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaSugestaoDeRodizio.TotalDeHoras}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaSugestaoDeRodizio.Tripulante2}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaSugestaoDeRodizio.FB}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaSugestaoDeRodizio.TotalDeHoras}</th>
                      <th>{this.locale.Escalas.ElaboracaoDeEscala.tabelaSugestaoDeRodizio.BaseAAlocar}</th>
                  </tr>
              </thead>
              <tbody>
                {Object.keys(self.state.sugestoes).map(function(sgt) {
                  return (
                    <tr>
                        <td>{sgt}</td>
                        <td>{self.state.sugestoes[sgt]["nome_1"]}</td>
                        <td>{self.state.sugestoes[sgt]["role_1"]}</td>
                        <td>{self.state.sugestoes[sgt]["total_h_1"]}</td>
                        <td>{self.state.sugestoes[sgt]["nome_2"]}</td>
                        <td>{self.state.sugestoes[sgt]["role_2"]}</td>
                        <td>{self.state.sugestoes[sgt]["total_h_2"]}</td>
                        <td><strong>{self.state.sugestoes[sgt]['base']}</strong></td>
                    </tr>
                  );
                })}
              </tbody>
          </table>
      </div>        
    </div>
    : ''
  }
</div>
    );
  }
}

export default SchedulesElaborateRotations;



// WEBPACK FOOTER //
// ./src/Components/Schedules/Elements/SchedulesElaborateRotations.js